
<div class="quick-add-box">
    <h3 class="d-none d-lg-block">Quick Add</h3>
    <div class="product-detail">
        <p>Enter Product Code or Barcode:</p>
        <div>
            <input type="text" #searchinput (keyup)="quickAdd($event, false)" [value]="searchWord" (change)="changeValue($event)" class="form-control" placeholder="E.g. 10344671">
            <div class="error" *ngIf="errorMessage"><img src="assets/images/error.svg" />
                {{errorMessage}}</div>
            <div class="enter-product">
                <span>Entered Product</span>
                <div class="product-price" *ngIf="quickProduct && quickProduct.short_desc">
                    <p *ngIf="quickProduct && quickProduct.short_desc">{{quickProduct.short_desc}}</p>
                   
                </div>
            </div>
            <div class="divider"></div>
            
            <div [ngClass]="{'d-flex  flex-column spinner-wrapper':'true', 'disabled':(errorMessage != '' || searchWord == '' || (quickProduct.back_in_stock == '0')) ? true : false}">

                  <h4 class="mb-3">Quantity:</h4>
                  <input type="text" (focus)="selectAllContent($event)" [attr.tabindex]="quickProduct.back_in_stock == '0' ? -1 : 0" #qytchange [ngClass]="{'form-control': true, 'disabled':quickProduct.back_in_stock == '0' ?true : false}" 
                  (input)="QuickAddqytChange($event)" 
                  (keyup)="qytEnter($event)" [value]="quickProduct.qty" 
                  placeholder="E.g. 10">
                  <div class="error" *ngIf="errorForqyt"><img src="assets/images/error.svg" />
                    {{errorForqyt}}</div>
                <input type='button' #Addqyt [attr.tabindex]="quickProduct.back_in_stock == '0' ? -1 : 0"
                [ngClass]="{'btn primary-btn mt-3 w-100 form-control':true, 'disabled':(errorForqyt != '' || errorMessage != '' || searchWord == '' || (quickProduct.back_in_stock == '0')) ? true : false}"
                id="btn_{{quickProduct.product_id}}" 
                (click)="addToCart(quickProduct, quickProduct.qty, true)" value='Add'>
            </div>

             

            <p *ngIf="quickProduct.back_in_stock == '0'"
                class="product-cart-status  d-flex"> <img
                    src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock.
            </p>
            <p class="product-cart-status" *ngIf="quickProduct.item_id != ''">
                <img src="../../assets/images/checkmark.svg" alt="checked icon"/>  
                This product is already in your cart.</p>
        </div>
    </div>
</div>